import React from 'react'
import { Box, Modal } from '@mui/material'
import { ExclamationTriangleFill } from 'react-bootstrap-icons'
import { t } from 'i18next'
import No from '../../Assets/Images/Login/no.svg'
import check from '../../Assets/Images/Login/check.png'
import './modalAlertGeneric.css'

const ModalAlertGeneric = ({
  isError,
  setIsError,
  setMessageSettings,
  messageSettings,
  isButtonClose,
  isOptionClose = true,
}) => {
  const handleClose = () => {
    setIsError(false)
    setMessageSettings({
      message: '',
      status: '',
    })
  }

  return (
    <Modal
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 99999,
      }}
      open={isError}
      data-testid="modal-alert-generic">
      <Box className="modal-box-message">
        <div className="generic-closing-button modal-pending">
          {isOptionClose && (
            <img
              src={No}
              onClick={handleClose}
              alt="close"
              data-testid="btn-close-modal-alert-generic"
            />
          )}
        </div>
        <div className="modal-content-penging">
          {messageSettings.status === 'success' ? (
            <>
              <img src={check} alt="check" />

              <p className="title-center-modal">{t(messageSettings.message)}</p>
            </>
          ) : messageSettings.status === 'error' ? (
            <>
              <ExclamationTriangleFill className="check-costs-page-warning-icon" />

              <p className="title-center-modal">{t(messageSettings.message)}</p>
              {isButtonClose && (
                <button
                  className="btn-close-modal"
                  onClick={handleClose}
                  data-testid="btn-understood-alert-generic">
                  Entendido
                </button>
              )}
            </>
          ) : null}
        </div>
      </Box>
    </Modal>
  )
}
export default ModalAlertGeneric
